import { FunctionComponent, useMemo } from 'react';
import './styles/ErrorPage.scss';

import { Stack,Container, Grid2 as Grid, Typography } from '@mui/material';

import { useAppSettings, useAuth, useScreenSize } from '@dw/hooks';
import { classNames } from '@dw/utils';
import { Card, CardHeader, CardContent, Button, PageHelmet } from '@dw/components/core';
import { buildSupportEmail } from '@dw/utils/supportUtils';

export const ErrorPage: FunctionComponent = () => {

  const { user } = useAuth();
  const { appSettings } = useAppSettings();
  const { isMobile, isSmallDesktop } = useScreenSize();

  const supportEmailDetails = useMemo(() => buildSupportEmail(appSettings, user), [appSettings, user]);

  const handleAppRestart = () => {
    window.location.reload();
  }

  return (
    <Stack
      flexDirection="row"
      justifyContent="center"
      className={classNames('dw-error-page', {
        mobile: isMobile,
        'small-desktop': isSmallDesktop
      })}
    >
      <PageHelmet title='Something went wrong | Dance World' />

      <Container maxWidth="sm">
        <Grid size={12} marginBottom={5}>
          <img
            src="/images/logo-white.webp"
            alt="Dance World Logo"
            className={classNames('img logo', {
              mobile: isMobile
            })}
          />
        </Grid>
        <Grid size={12}>
          <Card>
            <CardHeader title='Something went wrong' titleTypographyProps={{ textAlign: 'center', variant: 'h4' }} />
            <CardContent>
              <Stack rowGap={4}>
                <Typography textAlign='center'>
                  We are very sorry for this inconvenience, but our team has been notified and we are working to fix this in the background
                </Typography>

                <Stack rowGap={2}>
                  <Button onClick={handleAppRestart}>
                    Click here to reload
                  </Button>

                  <Typography variant='caption' textAlign='center'>
                    If the issue persists, please contact us on by <a className='dw-link' href={supportEmailDetails.href}>clicking here</a>
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Container>
    </Stack>
  )
}